import {useEffect} from 'react';
import {useSearchParams} from 'react-router';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';

const ToastNotification = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const notification = searchParams.get('_notification');
    const typeParam = searchParams.get('_type') as
        | 'info'
        | 'success'
        | 'warning'
        | 'error'
        | null; // Explicitly typing

    const {t} = useTranslation();

    useEffect(() => {
        if (notification) {
            const toastTypes = {
                info: toast.info,
                success: toast.success,
                warning: toast.warning,
                error: toast.error,
            };

            const showToast =
                typeParam && toastTypes[typeParam]
                    ? toastTypes[typeParam]
                    : toast;
            showToast(t(notification));

            setSearchParams(prev => {
                prev.delete('_notification');
                prev.delete('_type');
                return prev;
            });
        }
    }, [notification, typeParam, t, setSearchParams]);

    return null;
};

export default ToastNotification;
